module.exports = __webpack_public_path__ + "static/media/BlackSoup.987a8b03.png";